import Typography from 'typography';

const typography = new Typography({ baseFontSize: "122px" });

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js